// extracted by mini-css-extract-plugin
export default {"videoWrapper":"Video_videoWrapper__r9PZX","video":"Video_video__B-IYq","playBtn":"Video_playBtn__7LMGW","icon":"Video_icon__XU2aZ","spinnerWrapper":"Video_spinnerWrapper__9u3JX"};